import { render, staticRenderFns } from "./SaveConsultantBasicInformationSidebar.vue?vue&type=template&id=55c23486&scoped=true"
import script from "./SaveConsultantBasicInformationSidebar.vue?vue&type=script&lang=js"
export * from "./SaveConsultantBasicInformationSidebar.vue?vue&type=script&lang=js"
import style0 from "./SaveConsultantBasicInformationSidebar.vue?vue&type=style&index=0&id=55c23486&prod&lang=scss&scoped=true"
import style1 from "./SaveConsultantBasicInformationSidebar.vue?vue&type=style&index=1&id=55c23486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c23486",
  null
  
)

export default component.exports